import { defineBool } from '@spotify-internal/remote-config-properties';

export const policyReportEmailVerificationRollout = defineBool({
  name: 'policy-report-skip-email-verification-for-logged-in-users',
  description:
    'Rollout feature flag to define if the email verification step should render for the users that are already logged in across the Spotify environments.',
  default: false,
});

export const properties = [policyReportEmailVerificationRollout];
